import React from 'react';

/**
 * <PageHeader />
 *
 * Standard page header for every governance page. Replaces the 15 hand-rolled
 * <h1> + subtitle + action-row patterns currently scattered across admin pages.
 *
 * Usage:
 *   <PageHeader
 *     title="Tenants"
 *     subtitle="Manage AI governance across 25 tenants"
 *     actions={<Button>Add Tenant</Button>}
 *   />
 */
export default function PageHeader({ title, subtitle, actions, breadcrumb, eyebrow }) {
  return (
    <header className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between" data-testid="gov-page-header">
      <div className="min-w-0 flex-1">
        {breadcrumb && (
          <nav className="gov-text-tertiary mb-1 text-xs" aria-label="Breadcrumb">
            {breadcrumb}
          </nav>
        )}
        {eyebrow && (
          <div className="gov-label mb-1.5" data-testid="gov-page-eyebrow">{eyebrow}</div>
        )}
        <h1
          className="gov-text-primary text-3xl font-semibold tracking-tight"
          data-testid="gov-page-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="gov-text-secondary mt-1 text-sm" data-testid="gov-page-subtitle">
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex shrink-0 items-center gap-2" data-testid="gov-page-actions">
          {actions}
        </div>
      )}
    </header>
  );
}
